import {DurationHHMMSS} from "../../../helper/dateTime";
import {formatEffectWithIcon, getEffectTranslationKey} from "./Helper/FormatEffect";
import React, {ReactNode} from "react";
import {BuildingEffect, BuildingLevelData} from "../../index";
import ImageMisc from "../ImageMisc/ImageMisc";
import WithTooltip from "../../../react/components/ui/withTooltip";
import {useTranslationContext} from "../../../react/providers/TranslationContext";

type Props = {
    levelNode: ReactNode,
    levelData: BuildingLevelData,
    effects: BuildingEffect[],
    className: string,
    onClick?: () => void,
    onMouseOver?: () => void,
    isAggregated?: boolean,
}

export function BuildingLevelRow({levelNode, levelData, effects, onClick, onMouseOver, className, isAggregated} : Props) {
    const {translate} = useTranslationContext();
    const sum = levelData.resourceCost.r1
        + levelData.resourceCost.r2
        + levelData.resourceCost.r3
        + levelData.resourceCost.r4;
    return <div
        key={levelData.level}
        onClick={onClick}
        onMouseOver={onMouseOver}
        className={'buildingLevelRow ' + className}
    >
        <div style={{ gridArea: 'lvl' }}>{levelNode}</div>
        <div className='valueWithIcon' style={{ gridArea: 'r1' }}>
            {levelData.resourceCost.r1.toLocaleString()}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_wood')}><ImageMisc type='wood' size={16} /></WithTooltip></div>
        </div>
        <div className='valueWithIcon' style={{ gridArea: 'r2' }}>
            {levelData.resourceCost.r2.toLocaleString()}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_clay')}><ImageMisc type='clay' size={16} /></WithTooltip></div>
        </div>
        <div className='valueWithIcon' style={{ gridArea: 'r3' }}>
            {levelData.resourceCost.r3.toLocaleString()}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_iron')}><ImageMisc type='iron' size={16} /></WithTooltip></div>
        </div>
        <div className='valueWithIcon' style={{ gridArea: 'r4' }}>
            {levelData.resourceCost.r4.toLocaleString()}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_crop')}><ImageMisc type='crop' size={16} /></WithTooltip></div>
        </div>
        <div className='valueWithIcon' style={{ gridArea: 'sum' }}>
            {sum.toLocaleString()}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_sum')}><ImageMisc type='allResources' size={16} /></WithTooltip></div>
        </div>
        <div className='valueWithIcon' style={{ gridArea: 'pop' }}>
            {isAggregated ? '+' : ''}{levelData.population}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_population')}><ImageMisc type='population' size={16} /></WithTooltip></div>
        </div>
        <div className='valueWithIcon' style={{ gridArea: 'cp' }}>
            {isAggregated ? '+' : ''}{levelData.culturePoints}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_culturePoints')}><ImageMisc type='culturePoints' size={16} /></WithTooltip></div>
        </div>
        <div className='valueWithIcon' style={{ gridArea: 'time' }}>
            {DurationHHMMSS(levelData.buildingTime)}
            <div className='valueIcon'><WithTooltip tooltip={translate('header_time')}><ImageMisc type='time' size={16} /></WithTooltip></div>
        </div>
        {
            effects && levelData.effects && !isAggregated && effects.map((key, i) =>
                <div className='valueWithIcon' style={{ gridArea: 'f' + i }} key={key}>
                    {formatEffectWithIcon(key, levelData.effects[key], translate(getEffectTranslationKey(key)))}
                </div>
            )
        }
        {
            effects && isAggregated && effects.map((key, i) =>
                <div className='valueWithIcon' style={{ gridArea: 'f' + i }} key={key}></div>
            )
        }
    </div>
}
